import type { TMessages } from '@/types/TMessages'

export const messages = {
  proteinOption: 'Протеин: не менее {value}%',
  errors: {
    invalidDepartureDate: 'Не удалось определить период поставки. Проверьте выбранный временной интервал.',
    requestCreation: 'Не удалось создать заявку на продажу. Попробуйте позже.',
  },
} satisfies TMessages
